import $ from 'jquery';
import UI from 'root/ui';
import Constants from 'root/constants';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'root/view/base';
import Model_Integration_Linear from 'root/model/integration_linear';

// renders select list items for a given object ( Object<id,name> )
const render_items = (obj, current_id) => typeof obj !== 'undefined'
    ? Object.entries(obj).map(([id, name]) => `
        <li data-key="${Util.htmlEntities(id)}" ${id === current_id ? ' class="selected"' : ''}>
            ${id !== '' ? Util.htmlEntities(name) : name}
        </li>`).join('')
    : '';

export default View.extend({

    app_id: 0,
    send_options : null,

    linear_team_id: '',
    linear_project_id: '',
    linear_assignee_id: '',

    access_token : '',
    is_new       : false,
    is_auto      : false,
    auto_resolve : false,
    feedback_type : '',

    status_sync_resolve : false,
    status_sync_open    : false,
    status_sync_delete  : false,

    events: {
        'click .app-add'                             : 'onAddApp',
        'click .dropdown-app li'                     : 'onSelectApp',
        'click .dropdown-team li:not(.disabled)'     : 'onSelectTeam',
        'click .dropdown-project li:not(.disabled)'  : 'onSelectProject',
        'click .dropdown-assignee li:not(.disabled)' : 'onSelectAssignee',
        'click .dropdown-auto-send li'               : 'onSelectAutoSend',
        'click .status-sync-toggle-resolve'          : 'onToggleStatusSyncResolved',
        'click .status-sync-toggle-open'             : 'onToggleStatusSyncOpen',
        'click .status-sync-toggle-delete'           : 'onToggleStatusSyncDelete',
        'click .reconnect'                           : 'onReconnect',
        'submit form'                                : 'onSubmit'
    },

    dom_handlers: {
        onAddApp: function () {
            Modals.oauthLinear((access_token) => {
                Cache.app.request({
                    action: 'integration/addConnectedApp',
                    data: { type : 'linear', access_token },
                    success: (response) => {
                        Cache.connected_app_oauth.add(response);

                        if (this.model.isConnected()) {
                            Modals.editLinear();
                        } else {
                            Modals.activateLinear();
                        }
                    }
                });
            });
        },

        onSelectApp: function (e) {
            this.app_id = parseInt($(e.currentTarget).data('val'), 10);
            this.send_options = null;
            this.update();
            this.loadOptions();
        },

        onSelectTeam: function (e) {
            this.linear_team_id = $(e.currentTarget).data('key');
            const current_projects = this.send_options.projects[this.linear_team_id];
            this.linear_project_id = Object.entries(current_projects).length > 0
                ? Object.entries(current_projects)[0][0]
                : '';
            this.update();
        },

        onSelectProject: function (e) {
            this.linear_project_id = $(e.currentTarget).data('key');
            this.update();
        },

        onSelectAssignee: function (e) {
            this.linear_assignee_id = $(e.currentTarget).data('key');
            this.update();
        },

        onSelectAutoSend: function (e) {
            this.is_auto = $(e.currentTarget).data('is_auto') === 1;
            this.auto_resolve = $(e.currentTarget).data('auto_resolve') === 1;
            this.update();
        },

        onToggleStatusSyncResolved: function (e) {
            this.status_sync_resolve = !this.status_sync_resolve;
            $(e.currentTarget).toggleClass('switch-on switch-off');
        },

        onToggleStatusSyncOpen: function (e) {
            this.status_sync_open = !this.status_sync_open;
            $(e.currentTarget).toggleClass('switch-on switch-off');
        },

        onToggleStatusSyncDelete: function (e) {
            this.status_sync_delete = !this.status_sync_delete;
            $(e.currentTarget).toggleClass('switch-on switch-off');
        },

        onReconnect: function () {
            const connected_app = Cache.connected_app_oauth.get(this.app_id);

            if (connected_app) {
                Modals.reconnectConnectedApp(connected_app.get('app_type'), connected_app, () => {
                    Modals.editLinear();
                });
            } else {
                // TODO:?
            }
        },
        onSubmit: function () {
            const form_data = Form.getData(this.$el.find('form'));
            this.feedback_type = form_data.feedback_type.join(',');

            var data = {
                app_id              : this.app_id,
                is_auto             : this.is_auto,
                auto_resolve        : this.auto_resolve,
                feedback_type       : this.feedback_type,
                linear_team_id      : this.linear_team_id,
                linear_project_id   : this.linear_project_id,
                linear_assignee_id  : this.linear_assignee_id,
                status_sync_resolve : this.status_sync_resolve,
                status_sync_open    : this.status_sync_open,
                status_sync_delete  : this.status_sync_delete
            };

            this.$el.find('button:submit').addClass('loading').prop('disabled', false);

            Cache.app.request({
                action: this.is_new ? 'integration/activate' : 'integration/update',
                data: { ...data, type : 'linear', access_token : this.access_token },
                context: this,
                success: function (response) {
                    // a new app is created
                    if (this.access_token) {
                        Cache.connected_app_oauth.add(response.connected_app_oauth);
                    }

                    this.model.set(response.data);

                    if (this.is_new) {
                        Cache.integration_linear.add(this.model);
                        UI.success('Linear integration activated');
                        Cache.app.trackEvent('Integration Added', { integration: 'Linear' });
                    } else {
                        UI.success('Linear integration updated');
                    }

                    this.trigger('submit:success');
                },
                complete: function () {
                    this.$el.find('button:submit').removeClass('loading').prop('disabled', false);
                }
            });
        }
    },

    initialize: function (options) {
        this.app_id = options.app_id || 0;
        this.access_token = options.access_token || '';
        this.is_new = !!options.is_new;

        this.model = Cache.integration_linear.findWhere({project_id: Cache.default_project_id}) || new Model_Integration_Linear({
            account_id: Cache.account.get('id'),
            project_id: Cache.default_project_id
        });

        if (this.is_new) {
            this.feedback_type = [Constants.FEEDBACK_BUG, Constants.FEEDBACK_FEATURE_REQUEST, Constants.FEEDBACK_GENERAL].join(',');
        } else {
            this.app_id              = this.model.get('app_id');
            this.is_auto             = this.model.get('is_auto');
            this.auto_resolve        = this.model.get('auto_resolve');
            this.feedback_type       = this.model.get('feedback_type');
            this.linear_team_id      = this.model.get('linear_team_id');
            this.linear_project_id   = this.model.get('linear_project_id');
            this.linear_assignee_id  = this.model.get('linear_assignee_id');
            this.status_sync_resolve = this.model.get('status_sync_resolve');
            this.status_sync_open    = this.model.get('status_sync_open');
            this.status_sync_delete  = this.model.get('status_sync_delete');
        }
    },

    loadOptions: function () {
        Cache.app.request({
            action: 'integration/loadSendOptions',
            data: {
                type         : 'linear',
                app_id       : this.app_id,
                access_token : this.access_token
            },
            context: this,
            success: function (response) {
                this.send_options = response;
                this.send_options.users = { '': 'Unassigned', ...this.send_options.users };
                // Select a default team/project if one is not already selected
                if (this.linear_team_id === ''){
                    this.linear_team_id = Object.entries(this.send_options.teams)[0][0];
                    const current_projects = this.send_options.projects[this.linear_team_id];
                    this.linear_project_id = Object.entries(current_projects).length > 0
                        ? Object.entries(current_projects)[0][0]
                        : '';
                }
                this.update();
            },
            error: function () {
                this.renderError();
            }
        });
    },

    searchTeam: function (team_id) {
        return this.send_options?.teams[team_id] || '';
    },

    searchProject: function (project_id) {
        return this.send_options?.projects?.[this.linear_team_id]?.[project_id] || '';
    },

    searchAssignee: function (assignee_id) {
        return this.send_options?.users[assignee_id] || '';
    },

    renderError: function () {
        const connected_app = Cache.connected_app_oauth.get(this.app_id);

        var message = '<div class="error-dialog padding-30">' +
            '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
            '<h3>Authentication failed</h3>' +
            (connected_app ?
             '<p class="info">Your Linear account (<a class="navigation" href="/account/connected_app">' + connected_app.escape('custom_name') + '</a>) couldn\'t be connected.</p>' :
             '<p class="info">Your Linear account couldn\'t be connected.</p>') +
            '<button class="reconnect primary medium">Reconnect Linear</button>' +
            '</div>';

        this.$el.html(message);
    },

    update: function () {
        const app_selected = Cache.connected_app_oauth.get(this.app_id);
        const team_selected = this.searchTeam(this.linear_team_id);
        const project_selected = this.searchProject(this.linear_project_id);
        const assignee_selected = this.searchAssignee(this.linear_assignee_id);

        const app_items = Cache.connected_app_oauth.where({ app_type: 'linear' }).map((model) => {
            const integration_total = model.get('integration_total') || 0;
            return '<li data-val="' + model.id + '"' + (model.id === this.app_id ? ' class="active"' : '') + '>' +
                '<img class="icon-img" src="/image/linear_small.png">' +
                '<span class="font-weight-medium">' + model.escape('custom_name') + '</span>' +
                '<div class="text-info margin-top-4">' +
                '<div class="icon-img"></div>' +
                'Connected on: ' + Util.moment(model.get('create_time')) +
                (model.isDisabled() ? '<span class="badge-warning-invert badge-small margin-left-4">Expired</span>' : '') +
                '</div>' +
                '<div class="text-info margin-top-4">' +
                '<div class="icon-img"></div>' +
                'Used in ' + integration_total + ' integration' + (integration_total === 1 ? '' : 's') +
                '</div>' +
                '</li>';
        }).join('');

        const team_items = render_items(this.send_options?.teams, this.linear_team_id);
        const project_items = render_items(this.send_options?.projects?.[this.linear_team_id], this.linear_project_id);
        const assignee_items = render_items(this.send_options?.users, this.linear_assignee_id);

        const content =
        '<div class="grid-4-8">' +
            '<div><h5>Linear Settings</h5></div>' +
            '<div>' +
                (Cache.connected_app_oauth.where({ app_type: 'linear' }).length ?
                '<div class="row">' +
                    '<div class="field-label">Connection</div>' +
                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-app">' +
                        '<button type="button" class="dropdown-select dropdown-select-medium"><img class="icon-img" src="/image/linear_small.png">' + (app_selected ? app_selected.escape('custom_name') : '') + '</button>' +
                        '<div>' +
                            '<ul class="dropdown">' + app_items + '</ul>' +
                            '<div>' +
                                '<button type="button" class="app-add text-link small"><i class="fa-solid fa-plus margin-right-4"></i>Add connection</button>' +
                                '<button type="button" class="navigation text-link small float-right tooltip" data-title="Manage my apps" data-offset="0,10" href="/account/connected_app"><i class="fa-solid fa-cog"></i></button>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' : '') +
                '<div class="row">' +
                    '<div class="field-label">Team</div>' +
                    (this.send_options ?
                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-team">' +
                        '<button type="button" class="dropdown-select dropdown-select-medium">' + (team_selected ? Util.htmlEntities(team_selected) : team_selected) + '</button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search by team name">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select" data-empty="No teams found">' + team_items + '</ul>' +
                        '</div>' +
                    '</div>' : '<div class="loader-placeholder-regular"></div>') +
                '</div>' +
                '<div class="row">' +
                    '<div class="field-label">Project</div>' +
                    (this.send_options ?
                     '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-project">' +
                     '<button type="button" class="dropdown-select dropdown-select-medium">' +
                        (this.linear_project_id !== '' ? Util.htmlEntities(project_selected) : '<span class="placeholder-text">No project selected</span>') + '</button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search by project name">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select" data-empty="No projects found">' + (project_items || '<li class="disabled">No projects</li>') + '</ul>' +
                        '</div>' +
                    '</div>' : '<div class="loader-placeholder-regular"></div>') +
                '</div>' +
                '<div class="row">' +
                    '<div class="field-label">Assignee</div>' +
                    (this.send_options ?
                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-assignee">' +
                     `<button type="button" class="dropdown-select dropdown-select-medium ${this.linear_assignee_id === '' && 'placeholder-text'}">` +
                        (Util.htmlEntities(assignee_selected)) +
                     '</button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search by assignee name">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select" data-empty="No assignees found">' + assignee_items + '</ul>' +
                        '</div>' +
                    '</div>' : '<div class="loader-placeholder-regular"></div>') +
                '</div>' +
            '</div>' +
        '</div>' +
        '<hr>' +
        '<div class="grid-4-8">' +
            '<div><h5>Automation</h5></div>' +
            '<div>' +
                '<div class="row">' +
                    '<div class="field-label">Send feedback to Linear</div>' +
                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-auto-send">' +
                        '<button type="button" class="dropdown-select dropdown-select-medium">' +
                            (this.auto_resolve ? 'Automatically and resolve in Userback' : (this.is_auto ? 'Automatically' : 'Manually')) +
                        '</button>' +
                        '<div>' +
                            '<ul class="dropdown dropdown-select large">' +
                                '<li data-is_auto="0" data-auto_resolve="0"' + (!this.auto_resolve && !this.is_auto ? ' class="selected"' : '') + '>Manually</li>' +
                                '<li data-is_auto="1" data-auto_resolve="0"' + (!this.auto_resolve && this.is_auto ? ' class="selected"' : '') + '>Automatically</li>' +
                                '<li data-is_auto="1" data-auto_resolve="1"' + (this.auto_resolve ? ' class="selected"' : '') + '>Automatically and resolve in Userback</li>' +
                            '</ul>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="row">' +
                    '<div class="field-label">Select feedback type <i class="fas fa-question-circle info tooltip" data-title="Select what type of feedback to be sent to Linear automatically"></i></div>' +
                    '<div>' +
                        '<input type="checkbox" name="feedback_type" value="' + Constants.FEEDBACK_BUG + '"' + (this.feedback_type.indexOf(Constants.FEEDBACK_BUG.toString()) === -1 ? '' : ' checked') + '><label>Bug</label>' +
                        '<input type="checkbox" name="feedback_type" value="' + Constants.FEEDBACK_FEATURE_REQUEST + '"' + (this.feedback_type.indexOf(Constants.FEEDBACK_FEATURE_REQUEST.toString()) === -1 ? '' : ' checked') + '><label>Idea</label>' +
                        '<input type="checkbox" name="feedback_type" value="' + Constants.FEEDBACK_GENERAL + '"' + (this.feedback_type.indexOf(Constants.FEEDBACK_GENERAL.toString()) === -1 ? '' : ' checked') + '><label>General Feedback</label>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +
        '<hr>' +
        '<div class="grid-4-8">' +
            '<div><h5>Status Sync</h5></div>' +
            '<div>' +
                '<div class="row">' +
                    '<button type="button" class="status-sync-toggle-resolve ' + (this.status_sync_resolve ? 'switch-on' : 'switch-off') + ' small float-right" style="margin-top:-2px;"></button>' +
                    '<div class="margin-bottom-4"><b>Resolve</b></div>' +
                    '<div>When a task is resolved in Linear, resolve the feedback in Userback</div>' +
                '</div>' +
                '<div class="row">' +
                    '<button type="button" class="status-sync-toggle-open ' + (this.status_sync_open ? 'switch-on' : 'switch-off') + ' small float-right" style="margin-top:-2px;"></button>' +
                    '<div class="margin-bottom-4"><b>Re-open</b></div>' +
                    '<div>When a task is re-opened in Linear, re-open the feedback in Userback</div>' +
                '</div>' +
                '<div class="row">' +
                    '<button type="button" class="status-sync-toggle-delete ' + (this.status_sync_delete ? 'switch-on' : 'switch-off') + ' small float-right" style="margin-top:-2px;"></button>' +
                    '<div class="margin-bottom-4"><b>Delete</b></div>' +
                    '<div>When a task is deleted in Linear, delete the feedback including merged feedback in Userback</div>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.find('.form-main').html(content);
        this.$el.find('button:submit').prop('disabled', false);
        this.$el.find('input[name="feedback_type"]').prop('disabled', !this.is_auto);
    },

    render: function () {
        var content =
        '<form class="form-fluid">' +
            '<div class="form-main">' +
                '<div class="grid-4-8">' +
                    '<div><div class="loader-placeholder" style="width:100px;"></div></div>' +
                    '<div>' +
                        (Cache.connected_app_oauth.where({ app_type: 'linear' }).length ?
                        '<div class="loader-placeholder-small margin-bottom-8" style="width:100px;"></div>' +
                        '<div class="loader-placeholder-regular margin-bottom-20"></div>' : '') +
                        '<div class="loader-placeholder-small margin-bottom-8" style="width:100px;"></div>' +
                        '<div class="loader-placeholder-regular margin-bottom-20"></div>' +
                        '<div class="loader-placeholder-small margin-bottom-8" style="width:100px;"></div>' +
                        '<div class="loader-placeholder-regular margin-bottom-20"></div>' +
                        '<div class="loader-placeholder-small margin-bottom-8" style="width:100px;"></div>' +
                        '<div class="loader-placeholder-regular margin-bottom-20"></div>' +
                    '</div>' +
                '</div>' +
                '<hr>' +
                '<div class="grid-4-8">' +
                    '<div><div class="loader-placeholder" style="width:100px;"></div></div>' +
                    '<div>' +
                        '<div class="loader-placeholder-small margin-bottom-8" style="width:100px;"></div>' +
                        '<div class="loader-placeholder-regular"></div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<hr>' +
            '<div class="sidebar-bottom' + (this.is_new ? ' animated' : '') + '">' +
                '<button type="submit" class="primary" disabled>' + (this.is_new ? 'Complete Setup' : 'Save Changes') + '</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        if (!this.send_options) {
            this.loadOptions();
        }

        return this;
    }
});
